import { connect } from 'react-redux'
import React, { Component } from 'react';

import { closeModalTermsOfUse } from '../../../actions/purchaseActions'


export class ModalTermsOfUse extends Component {
    render() {
        const selectedPlan = this.props.plans.length && this.props.plans[0];
        const provider = this.props.providers.filter(pr => selectedPlan.provider_code === pr.code)
        let providerName = '';
        let termsUrl = '';

        if (provider.length) {
            providerName = provider[0].name
            termsUrl = provider[0].terms_url
        }

        if (!this.props.isModalTermsOfUseActive)
            return <div />

        return (
            <div className="comp_modalpagamento">
                <div className="modalcontents">
                    <div className="contents">

                        <div className="modaltop">
                            <div className="title">Termos de uso {providerName}</div>
                            <div onClick={this.props.closeModalTermsOfUse} className="close-btn" > &times; </div>
                        </div>
                        <div className="modalmiddle">
                            <p>Sugerimos uma leitura detalhada do documento antes de finalizar a compra.</p>
                            <p>Link para download do Termo em PORTUGUÊS:</p>
                            <p >
                                <a href={termsUrl} target="_blank" className="button"><span>CLIQUE AQUI</span>
                                    <span>
                                        <img src="/assets/images/attention.svg" alt="" />
                                    </span>
                                </a>
                            </p>
                        </div>
                        <div className="modalbotton">
                            <strong>Importante:</strong> para prosseguir com a contratação, é necessário concordar com os termos e condições de uso de cada seguradora.
                        </div>

                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        isModalTermsOfUseActive: state.purchase.isModalTermsOfUseActive,
        plans: state.search.plans,
        providers: state.global.providers,
    }),
    {
        closeModalTermsOfUse
    }
)(ModalTermsOfUse);



// WEBPACK FOOTER //
// ./src/components/purchase/modal_terms_of_use/ModalTermsOfUse.jsx